import(/* webpackMode: "eager" */ "/vercel/path0/app/projets/cardsParallax/page.jsx")